<template>
    <div>
        <div class="modal fade" id="pageTemplateModal" tabindex="-1" role="dialog" aria-labelledby="pageTemplateModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="pageTemplateModalLabel">Web Page Templates</h5>
                        <button type="button" class="btn-close" @click="noHandler" aria-label="Close">

                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="alert alert-success" role="alert">
                            Jump start your development by importing the following web pages into your site.
                        </div>

                        <h4>{{websiteTemplate.name}}</h4>

                        <div>
                            Pages to import
                        </div>
                        <ul class="list-group">
                            <li v-for="page in pages" class="list-group-item">{{page.title}}</li>
                        </ul>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="yesHandler" >Import Pages</button>
                        <button type="button" class="btn btn-secondary " @click="noHandler">cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import SiteService from "../services/SiteService";

    export default {
        name: 'WebpageTemplateModal',
        props: {
            yesEvent: Function,
            websiteTemplate: Object
        },
        data () {
            return {
                model: webase.model,
                service: new SiteService(),
                pages: [],
                currentModal: null,
                modalElement: null,
            }
        },
        mounted() {
            this.modalElement = document.getElementById('pageTemplateModal')
            this.currentModal = new bootstrap.Modal(this.modalElement)

            this.modalElement.addEventListener('hidden.bs.modal', this.onModalHidden)

            this.currentModal.show()

            this.service.get(this.websiteTemplate.website_id).then((response) => {
                this.pages = response.webpages
            })
        },
        beforeUnmount() {
            this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden)
        },
        methods: {
            onModalHidden() {
                this.$emit('noEvent')
            },
            noHandler(e) {
                this.currentModal.hide()
            },
            yesHandler(e) {

                // call the parent's "yesEvent"
                if(this.yesEvent) {
                    this.yesEvent()
                }
                // hide the modal
                this.noHandler()
            }
        }
    }
</script>
